export default __webpack_public_path__ + "static/media/rk1.bb44d706.png";